import { BonusStatus } from '@my-account/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { BONUS_STATUS } from '../my-account-state';

export const LOAD_BONUS_STATUS = '[MyAccount] Load bonus status';
export const LOAD_BONUS_STATUS_FAIL = '[MyAccount] Load bonus status Fail';
export const LOAD_BONUS_STATUS_SUCCESS = '[MyAccount] Load bonus status Success';
export const SET_BONUS_STATUS = '[MyAccount] Set balance status';
export const LOAD_BONUS_STATUS_RESET = '[MyAccount] Load bonus status reset';

export class LoadBonusStatus extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_BONUS_STATUS;

  constructor() {
    super(BONUS_STATUS);
  }
}

export class LoadBonusStatusFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_BONUS_STATUS_FAIL;

  constructor() {
    super(BONUS_STATUS);
  }
}

export class LoadBonusStatusSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_BONUS_STATUS_SUCCESS;

  constructor(public payload: BonusStatus) {
    super(BONUS_STATUS);
  }
}

export class LoadBonusStatusReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_BONUS_STATUS_RESET;

  constructor() {
    super(BONUS_STATUS);
  }
}

export class SetBonusStatus implements Action {
  readonly type = SET_BONUS_STATUS;

  constructor() {}
}
export type BonusStatusActions =
  | LoadBonusStatus
  | LoadBonusStatusSuccess
  | LoadBonusStatusFail
  | SetBonusStatus
  | LoadBonusStatusReset;
